import { Table } from '@ui';
import styled from 'styled-components';

export const TableSC = styled(Table)`
  tbody {
    tr {
      td {
        .name-link {
          color: ${({ theme }) => theme.color.tint.primary};
        }

        &:first-child {
          width: 58px;
        }
      }
    }
  }

  td:last-child {
    text-align: right;
  }

  tr > th:nth-child(2),
  tr > td:nth-child(2) {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  tr > th:last-child,
  tr > td:last-child {
    position: sticky;
    right: 0;
    z-index: 1;
  }
` as typeof Table;
